// extracted by mini-css-extract-plugin
export var carrierIcon = "_ys-0";
export var carrierLogo = "_ys-1";
export var detailsSection = "_ys-2";